export default __webpack_public_path__ + "static/media/Praktiko_logo_head_only.38d30a11.svg";